import { gql } from '@apollo/client';
import { SharedFolder } from 'types';
import { SHARED_FOLDER_FRAGMENT } from './FolderFragments';

export const GET_VISIBLE_FOLDERS_BY_FOLDER_TYPE_QUERY = gql`
  query GetVisibleDocumentsFromFolderQuery(
    $getVisibleFoldersByFolderTypeInput: GetVisibleFoldersByFolderTypeInput!
  ) {
    visibleFoldersFromFolderType(
      getVisibleFoldersFromFolderTypeInput: $getVisibleFoldersByFolderTypeInput
    ) {
      folders {
        ...SharedFolder
      }
      errorReason
    }
  }
  ${SHARED_FOLDER_FRAGMENT}
`;

export enum GetVisibleFoldersFromFolderError {
  NOT_LINKED = 'NOT_LINKED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type GetVisibleFoldersFromFolderOutput = {
  visibleFoldersFromFolderType: {
    errorReason: GetVisibleFoldersFromFolderError;
    folders: SharedFolder[];
  };
};
